import { UPDATE_GLOBAL_SETTING, USER_GLOBAL_SETTINGS, GET_WP_QR_CODE, GET_WP_SETTING, GET_WP_MESSAGE } from '../types';

const initialState = {
   globalSettings: null,
   totalCount: 0,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case USER_GLOBAL_SETTINGS:
         return {
            ...state,
            globalSettings: payload || null,
         };

      case UPDATE_GLOBAL_SETTING:
         return {
            ...state,
            globalSettings: payload,
         };

      case GET_WP_QR_CODE:
         return {
            ...state,
            wpQrCode: payload,
         };

      case GET_WP_SETTING:
         return {
            ...state,
            wpSetting: payload,
         };

      case GET_WP_MESSAGE:
         return {
            ...state,
            wpMessage: payload,
         };

      default:
         return state;
   }
};

export default reducer;
